module.exports = __webpack_public_path__ + "static/image9-cd4572d8be6903c84cc2013148afd201.jpg";